import {
  Component, OnInit, Input, Output, AfterContentInit,
  ContentChild, AfterViewInit, ViewChild, ViewChildren, EventEmitter, HostListener, Renderer2,
  ElementRef
} from '@angular/core';
import { SnotifyService } from 'ng-snotify';
import { SharedDataService } from '../../service/shared-data.service';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { DragulaService } from 'ng2-dragula';

@Component({
  selector: 'tags-creator',
  templateUrl: './tags-creator.component.html',
  styleUrls: ['./tags-creator.component.scss']
})
export class TagsCreatorComponent implements OnInit {

  tags: string[];
  suggestionTags: string[];
  path: string;
  tag = '';
  tagEdit = false;
  tagEditId: number;
  textValue: string;
  textEditFlag = false;
  setFocusOnInput: boolean;
  imageInputFlag: boolean;
  editFlag = false;
  autosuggest = false;
  autoCompletetionList = null;
  invalidEmail= false;

  insideTagSuggest = false;
  tagQuery = '';
  filteredSuggestion = [];

  currentSelection = null;
  newFlag = false;
  inputIdValue: string;
  @ViewChildren('tagInput') tagInput;
  @ViewChildren('input') vc;
  @ViewChild('suggestRef',{static: false}) suggestRefer: ElementRef;
  @ViewChild('listRef',{static: false}) listRef: ElementRef;
  @Input() seriesPageIDValidation: boolean = false;
  nominreq: boolean;
  domainConfig: any;
  isAutoSelectTopic: any;
  autoCompleteTopic: any;
  isTopic: boolean;
  marketSuggestionFlag: boolean;
  supplyTag: boolean;
  toolTag: boolean;
  marketSuggestions = [];
  filteredMarketSuggestions: any;
  defaulttags: boolean;
  @Input ('enableEmailValidation') enableEmailValidation: boolean;
  @Input()
  set noMinReq(noMinReq: boolean) {
    this.nominreq = noMinReq ? noMinReq : false;
    if (this.nominreq) {
      this.currentSelection = 0;
    }
  }

  @Input()
  set data(tagList: string[]) {
    this.tags = (tagList && (tagList.length > 0)) ? JSON.parse(JSON.stringify(tagList)) : [];
  }

  @Input()
  set textEdit(edit: boolean) {
    this.textEditFlag = edit ? edit : false;
  }

  @Input()
  set isTopicFlag(isTopic: boolean) {
    this.isTopic = isTopic;
  }
  @Input()
  set setFocus(setFocus: boolean) {
    this.setFocusOnInput = setFocus ? setFocus : false;
    if (setFocus) {
      if (!this.autosuggest) {
        this.vc.first.nativeElement.focus();
      } else {
        this.tagInput['_results'][0].nativeElement.focus();
      }
    }
  }

  @Input()
  set editable(editable: boolean) {
    this.editFlag = editable ? editable : false;
  }
  @Input()
  set marketSuggest(flag: boolean) {
    this.marketSuggestionFlag = flag ? flag : false;
  }

  @Input()
  set autoSuggest(autoSuggest: boolean) {
    this.autosuggest = autoSuggest ? autoSuggest : false;
  }

  @Input()
  set broadInput(broadInput: boolean) {
    this.imageInputFlag = broadInput ? broadInput : false;
  }

  @Input() storyTags: boolean;

  @Input() singleValued: boolean;
  @Input() isEntertainment: boolean;
  @Input() isMovies: boolean;
  @Input() isCricketTeam:boolean;

  @Input()
  set supplyTags(flag: boolean) {
    this.supplyTag = flag ? flag : false;
  }

  @Input()
  set toolTags(flag: boolean) {
    this.toolTag = flag ? flag : false;
  }

  @Input()
  set displayText(displayText: string) {
    this.textValue = (displayText && (displayText.trim() !== '')) ? displayText : '';
  }

  @Input()
  set idInput(idInput: string) {
    this.inputIdValue = (idInput && (idInput.trim() !== '')) ? idInput : '';
  }

  @Input()
  set suggestions(suggestions: string[]) {
    this.suggestionTags = (suggestions && (suggestions.length > 0)) ? suggestions : null;
  }

  @Input()
  set autocompletelist(autocompletelist: any) {
    this.autoCompletetionList = autocompletelist ? autocompletelist : null;
  }

  @Output() changefn = new EventEmitter<any>();
  @Output() clickfn = new EventEmitter<any>();
  @Output() focusoutfn = new EventEmitter<any>();
  @Output() suggestionAddfn = new EventEmitter<any>();
  @Output() focusedfn = new EventEmitter<any>();
  @Output() createTopicsOnFly = new EventEmitter<any>();
  @Input() topic: boolean;
  @Input() searchByCode: boolean;
  @Input() keywordDensity: boolean;
  @Input() notRemovable: boolean;
  @Input() isDataKeyValuePair: boolean;
  @Input() isMarket: boolean = false;
  @Input() enableDrag: boolean = false;
  @Input() createTopicsOnFlyEnabled : boolean = false;

  isLongReadLogicEnabled = false;
  constructor(
    private snotify: SnotifyService,
    private sharedService: SharedDataService,
    private renderer: Renderer2,
    private config: Config,
    private restService: RestDataService,private dragulaService: DragulaService
  ) {
    this.domainConfig = this.sharedService.currentDomainConfiguration;
    this.isAutoSelectTopic = this.domainConfig['config']['story']['autoCompleteTopic'];
    const bag: any = this.dragulaService.find('keywords-bag');
    if (bag === undefined) {
      dragulaService.setOptions('keywords-bag', {
        copy: function (el, source) {
          return false;
        },
        accepts: function (el, target, source, sibling) {
          return true;
        },
        moves: function (el: any, container: any, handle: any): any {
          return true;
        },
        copySortSource: false
      });
    }
    dragulaService.dropModel.subscribe((value) => {
      if(this.enableDrag)
      {
        console.log(this.tags);
        this.changeDetected();
      }
    });
  }

  ngOnInit() {
    const domainConfig = this.sharedService.currentDomainConfiguration;
    this.isLongReadLogicEnabled = !!this.topic && !!(domainConfig && domainConfig['config']
    && domainConfig['config']['story'] && domainConfig['config']['story']['longReadTopic']
    && domainConfig['config']['story']['longReadTopic'] === 'true');
    this.autoCompleteTopic =  this.domainConfig['config']['story']['autoCompleteTopic'];
    if(this.marketSuggestionFlag) {
      this.getMarketList();
    }
  }


  focusIn() {
    this.insideTagSuggest = true;
    if (this.tagQuery.trim() === '') {
      this.tagQuery = '';
      this.filteredSuggestion = this.autoCompletetionList;
    }
    this.focusedfn.emit();
  }

  focusOut() {
    // if (this.filteredSuggestion.length === 0) {
    //   this.insideTagSuggest = false;
    //   this.currentSelection = null;
    //   this.tagQuery = '';
    //   this.filteredSuggestion = [];
    // }
  }

  focusOnInput() {
    this.tagInput['_results'][0].nativeElement.focus();
  }

  selectAutoComplete(item) {
    if(this.tags && this.tags.length >= 1 && this.singleValued) {
      this.snotify.info( 'You can add only one value', '', this.sharedService.getConfig(false));
      return;
    }
   let tagsArr = [];
    if (typeof(item)==='string' && item.indexOf(',') > -1) {
      tagsArr = item.split(',').map(val => val.trim());
      tagsArr = tagsArr.filter((tag, i) => tagsArr.indexOf(tag) === i);
    }
    else
    {
      tagsArr.push(item);
    }
    if (item) {
      this.tagQuery = '';
      this.tag = '';
      const upperCaseNames = this.tags.map(value => {
        if (this.isDataKeyValuePair) {
          if(this.isMarket) {
            return value['code'];
          } else {
            return value['id'];
          }
        } else {
          return value.toUpperCase();
        }
      });
      tagsArr.forEach(item =>{
      const name = item;
      if (this.isDataKeyValuePair) {
        if(this.isMarket) {
          //for Market element
          if (!upperCaseNames.includes(name.code)) {
            this.tags.push(item);
          } else {
            if(this.supplyTag)
              this.snotify.info('\"' + name.name + '\" supply already exists', '', this.sharedService.getConfig(false));
            else if(this.toolTag)
              this.snotify.info('\"' + name.name + '\" tool already exists', '', this.sharedService.getConfig(false));
            else
              this.snotify.info('\"' + name.name + '\" tag already exists', '', this.sharedService.getConfig(false));
          }
        } else {
          if (!upperCaseNames.includes(name.id)) {
            this.tags.push(item);
          } else {
            if(this.supplyTag)
              this.snotify.info('\"' + name.name + '\" supply already exists', '', this.sharedService.getConfig(false));
            else if(this.toolTag)
              this.snotify.info('\"' + name.name + '\" tool already exists', '', this.sharedService.getConfig(false));
            else
              this.snotify.info('\"' + name.name + '\" tag already exists', '', this.sharedService.getConfig(false));
          }
        }
      } else {
        if (upperCaseNames.indexOf(name.trim().toUpperCase()) < 0) {
          this.tags.push(item);
          if (this.isLongReadLogicEnabled && (item.trim().toUpperCase() === 'LONG-READS') && !this.tags.includes('long-story')) {
            this.tags.push('long-story');
          }
        } else {
          if(this.supplyTag)
              this.snotify.info('\"' + name + '\" supply already exists', '', this.sharedService.getConfig(false));
            else if(this.toolTag)
              this.snotify.info('\"' + name + '\" tool already exists', '', this.sharedService.getConfig(false));
            else
              this.snotify.info('\"' + name + '\" tag already exists', '', this.sharedService.getConfig(false));
        }
      }
      this.changeDetected();
      // add item to list;
      this.insideTagSuggest = false;
      if (!this.nominreq) {
        this.filteredSuggestion = [];
      }
      });
    }
  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    if (this.autosuggest && !this.editFlag) {

      const clickedComponent = event.target;
      if (clickedComponent === this.tagInput['_results'][0].nativeElement) {
        this.insideTagSuggest = true;
        if (this.tagQuery.trim() === '') {
          this.tagQuery = '';
          this.filteredSuggestion = this.autoCompletetionList;
        }
      } else {
        this.insideTagSuggest = false;
        this.currentSelection = null;
        this.tagQuery = '';
        this.filteredSuggestion = [];
      }

      if (this.suggestRefer.nativeElement.contains(clickedComponent)) {
        this.newFlag = true;
        this.insideTagSuggest = true;
      }
    }
  }
  onBlurMethod() {
  }

  filterAutoComplete(event) {
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.keyCode !== 'Enter' && event.keyCode !== 38 && event.keyCode !== 40) {
      if (!this.isTopic) {
        if (!this.storyTags) {
          if ((this.nominreq ? true : (this.tagQuery !== '')) && this.insideTagSuggest) {
            if (this.isDataKeyValuePair) {
              if(this.searchByCode) {
                this.filteredSuggestion = this.autoCompletetionList.filter(function (el) {
                  if(el.bseCode === this.tagQuery || (el.nsiCode && el.nsiCode.toLowerCase() === (this.tagQuery.toLowerCase())) || (el.name.toLowerCase().indexOf(this.tagQuery.toLowerCase()) > -1) ) {
                    return 1;
                  } else {
                    return 0;
                  }
                }.bind(this));

              } else {
                this.filteredSuggestion = this.autoCompletetionList.filter(function (el) {
                  return el.name.toLowerCase().indexOf(this.tagQuery.toLowerCase()) > -1;
                }.bind(this));
              }
            } else {
              this.filteredSuggestion = this.autoCompletetionList.filter(function (el) {
                return el.toLowerCase().indexOf(this.tagQuery.toLowerCase()) > -1;
              }.bind(this));
            }
          } else {
            this.insideTagSuggest = true;
            if (!this.nominreq) {
              this.filteredSuggestion = [];
            }
          }
        } else {
          if ((this.tag.trim().length > 0) && this.insideTagSuggest && this.isEntertainment) {
              const url = this.config.get('product').baseUrl
              + '/api/cms/celebrity'
              + '?page=0&size=5&search=,text~' + StaticDataService.encodeSpecialChar(this.tag);
            this.restService.http_get(url)
              .subscribe(data => {
                const dataArray = data.content.map(celebrity => celebrity.celebrityName);
                dataArray.unshift(this.tag);
                this.filteredSuggestion = dataArray;
              },
                error => {
                });
          }else if ((this.tag.trim().length > 0) && this.insideTagSuggest && this.isMovies) {
            // let dataArray = [];
            const url = this.config.get('product').baseUrl
            + '/api/cms/movie'
            + '?page=0&size=5&search=,text~' + StaticDataService.encodeSpecialChar(this.tag);
          this.restService.http_get(url)
            .subscribe(data => {
             const dataArray = data.content.map(celebrity => celebrity.movieName);
              dataArray.unshift(this.tag);
              this.filteredSuggestion = dataArray;
            },
              error => {
              });
            }
           else if((this.tag.trim().length > 2) && this.insideTagSuggest){
            const url = this.config.get('product').baseUrl
              + '/api/cms/story/suggestions'
              + '?text=' + StaticDataService.encodeSpecialChar(this.tag);
            this.restService.http_get(url)
              .subscribe(data => {
                const dataArray = data;
                dataArray.unshift(this.tag);
                this.filteredSuggestion = dataArray;
                if(this.marketSuggestionFlag) {
                  // this.addMarketKeywords()
                  // this.filteredSuggestion = this.filteredSuggestion.concat(this.marketSuggestions);
                  this.filteredMarketSuggestions = this.marketSuggestions.filter(function (el) {
                    return el.toLowerCase().indexOf(this.tag.toLowerCase()) > -1;
                  }.bind(this));
                  this.filteredSuggestion = this.filteredSuggestion.concat(this.filteredMarketSuggestions);
                  // console.log(this.filteredMarketSuggestions)
                }
              },
                error => {
                });
          } else {
            this.insideTagSuggest = true;
            this.filteredSuggestion = [];
          }
        }
      } else {
        if ((this.nominreq ? true : (this.tagQuery !== '')) && this.insideTagSuggest) {
          if(this.tagQuery.length > 1) {
            const url = this.config.get('product').baseUrl
            + '/api/cms/story/editor/topics?page=0&size=100&sort=lastModifiedDate,desc&fields=alias&'
            + 'search=alias~'+this.tagQuery.toLowerCase()+',pageType:TOPIC,status:PUBLISHED,pageType!EXTERNAL';
            if(this.isCricketTeam){
              this.restService.http_get(url + ',metadata.cricketTeamPage%23true').subscribe(
              data => {
                this.filteredSuggestion = [];
                this.filteredSuggestion = data;
              });
            }
            else{
            this.restService.http_get(url).subscribe(
            data => {
              this.filteredSuggestion = [];
              this.filteredSuggestion = data;
            }
          );
        }
          }
        } else {
          this.insideTagSuggest = true;
            if (!this.nominreq) {
              this.filteredSuggestion = [];
            }
        }
      }
    }
  }
  getMarketList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/market/indices?type=!mf&size=10000')
    .subscribe(
      data => {
        // this.marketSuggestion = data;
        // console.log(data);
        let op = data.map(function(item) {
          if(item['keywordList']) {
            return item['keywordList'];
          }
          return null;
        }).filter(Boolean);
        this.marketSuggestions = (op.flat())
        // console.log(this.marketKeywords)
      }
    );
  }

  validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    this.invalidEmail = true;
    return emailRegex.test(email);
  }

  onKeydown(event) {

    // this.filterAutoComplete();
    if (event.key === 'Enter') {
      if (this.isTopic !== true) {
        if (!this.storyTags) {
            this.selectAutoComplete(this.filteredSuggestion[this.currentSelection]);
        } else {
          if(this.isMovies || this.isEntertainment){
            if(this.filteredSuggestion == null)
            this.filteredSuggestion = [];
            this.tag = (this.filteredSuggestion.length > 0) ? this.filteredSuggestion[this.currentSelection] : this.tag;
            this.addTag(event);
          }else{
          this.tag = (this.filteredSuggestion.length > 0) ? this.filteredSuggestion[this.currentSelection] : this.tag;
          this.addTag(event);
          }
        }
      } else {
        if (!this.storyTags) {
          this.autoAddTopics();
      } else {
        this.tag = (this.filteredSuggestion.length > 0) ? this.filteredSuggestion[this.currentSelection] : this.tag;
        this.addTag(event);
      }
      }
    } else if (event.keyCode === 40) {
      event.preventDefault();
      if (this.currentSelection < (this.filteredSuggestion.length - 1)) {
        this.currentSelection += 1;
        this.listRef.nativeElement.scrollBy(0, 23);
        event.stopPropagation();
      }
    } else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
        this.listRef.nativeElement.scrollBy(0, -23);
        event.stopPropagation();
      }
    } else if (event.keyCode === 9 || event.keyCode === 27) {
      this.insideTagSuggest = false;
      this.currentSelection = null;
      this.tagQuery = '';
      this.tag = '';
      this.filteredSuggestion = [];
    } else {
      this.currentSelection = 0;
    }
    return true;
  }
  autoAddTopics() {
    if (this.filteredSuggestion) {
      this.tagQuery = '';
      this.tag = '';
      const upperCaseNames = this.tags.map(value => {
        return value.toUpperCase();
      });
      const topicsToBeAdded = this.filteredSuggestion.splice(0, 3);
      for (var item of topicsToBeAdded) {
        if (upperCaseNames.indexOf(item.trim().toUpperCase()) < 0) {
          this.tags.push(item);
        }
      }
      this.changeDetected();
      this.insideTagSuggest = false;
      if (!this.nominreq) {
        this.filteredSuggestion = [];
      }
    }
  }

  focusOff() {
    this.setFocusOnInput = false;
  }

  addTag(event: any) {
    if (event.keyCode === 13) {
      if (this.tag.trim() !== '') {
        if (this.tagEdit === false) {
          this.addTagfn(this.tags);
        } else {
          this.changeTagfn(this.tags);
        }
      }
      this.tag = '';
    }
  }

  addSuggested(index: any) {
    this.tags.push(this.suggestionTags[index]);
    this.changeDetected();
    this.suggestionAddfn.emit(index);
    // this.addTagfn(this.suggestionTags[index]);
  }

  addTagfn(obj) {
    if(this.tags && this.tags.length >= 1  && this.singleValued) {
      this.snotify.info( 'You can add only one value', '', this.sharedService.getConfig(false));
      return;
    }
    const upperCaseNames = obj.map(value => {
      return value.toUpperCase();
    });
    if(this.enableEmailValidation){
      if (this.validateEmail(this.tag)) {
        this.invalidEmail = false;
      } else{
        this.invalidEmail = true;
        return;
      }
   } 
    if (this.tag.indexOf(',') > -1) {
      let tagsArr = this.tag.split(',').map(val => val.trim());
      tagsArr = tagsArr.filter((tag, i) => tagsArr.indexOf(tag) === i);
      for (let j = 0; j <= tagsArr.length; j++) {
        const tag = tagsArr[j];
        if (tag && tag.trim() !== '' && (j < tagsArr.length)) {
          if (upperCaseNames.indexOf(tag.trim().toUpperCase()) > -1) {
            if(this.supplyTag)
              this.snotify.info('\"' + tag + '\" supply already exists', '', this.sharedService.getConfig(false));
            else if(this.toolTag)
              this.snotify.info('\"' + tag + '\" tool already exists', '', this.sharedService.getConfig(false));
            else
              this.snotify.info('\"' + tag + '\" tag already exists', '', this.sharedService.getConfig(false));
          } else {
            obj.push(tag.trim());
          }
        }
        if (j === tagsArr.length) {
          setTimeout(e => {
            this.changeDetected();
          }, 1);
        }
      }
    } else {
      if (upperCaseNames.indexOf(this.tag.trim().toUpperCase()) > -1) {
        if(this.supplyTag)
          this.snotify.info('\"' + this.tag + '\" supply already exists', '', this.sharedService.getConfig(false));
        else if(this.toolTag)
          this.snotify.info('\"' + this.tag + '\" tool already exists', '', this.sharedService.getConfig(false));
        else
          this.snotify.info('\"' + this.tag + '\" tag already exists', '', this.sharedService.getConfig(false));
      } else if(this.seriesPageIDValidation && this.validateSeriesId(this.tag)){
        this.snotify.info('\"' + this.tag + '\" only alphanumeric tag allowed', '', this.sharedService.getConfig(false));
      }else {
        obj.push(this.tag.trim());
        this.changeDetected();
      }
    }
  }

  changeTagfn(obj) {
    obj[obj.indexOf(this.tagEditId)] = this.tag;
    this.tagEdit = false;
    this.tagEditId = null;
    this.changeDetected();
  }

  deleteTag(index) {
    this.deleteTagfn(index, this.tags);
  }

  deleteTagfn(index, obj) {
    if (obj.indexOf(this.tagEditId) === index) {
      this.tag = '';
      this.tagEdit = false;
      this.tagEditId = null;
    }
    obj.splice(index, 1);
    this.changeDetected();
  }

  editTag(index) {
    this.editTagfn(index, this.tags);
  }


  editTagfn(index, obj) {
    this.tag = obj[index];
    this.tagEdit = true;
    this.tagEditId = obj[index];
    this.vc.first.nativeElement.focus();
    this.changeDetected();
  }

  changeDetected() {
    if (this.isDataKeyValuePair) {
      this.changefn.emit(this.tags);
    } else {
      this.changefn.emit(this.tags.map(el => el.trim()));
      if(this.createTopicsOnFlyEnabled){
        this.createTopicsOnFly.emit();
      }
    }
    this.focusedfn.emit();
  }

  customFunc(ev) {
    this.clickfn.emit(ev);
  }

  focusOutFn(ev) {
    this.focusoutfn.emit(ev);
  }

  trackByName(index, instructor) {
    return instructor;
  }

  validateSeriesId(input: string) {
    const alphanumericPattern = /^[a-zA-Z0-9]+$/;
    if (!alphanumericPattern.test(input)) {
      console.log('Input should contain only alphanumeric characters.');
      return true;
    } else {
      return false;
    }
  }
}
